import React, { useContext } from "react";
import "./PurchaseOrderProgressTracker.scss";
import IPurchase_Order from "../../../models/IPurchase_Order";
import IPurchase_Order_Progress_State from "../../../models/IPurchase_Order_Progress_State";
import OrderEntryService from "../../../services/OrderEntryService";
import OwLabel from "../OwLabel/OwLabel";
import UIService from "../../../services/UIService";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    purchaseOrder: IPurchase_Order;
};

export const PurchaseOrderProgressTracker = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const getChevron = (isSelected?: boolean): any => {
        return (
            <div className={"line " + (isSelected ? "selected" : "")}>
                <i className={"fas fa-chevron-double-right"} />
            </div>
        );
    };

    const getStepMarker = (title: string, isSelected?: boolean, showTitleOnMobile?: boolean): any => {
        return (
            <div id={`progress-${title}`} className={"d-flex flex-column " + (isSelected ? "selected" : "")}>
                <div className={"d-flex justify-content-center mb-2"}>
                    <div className={"circle"} />
                </div>
                <div className={"font-small text-muted text-truncate-mobile step-title " + (showTitleOnMobile ? "" : "")}>
                    <OwLabel noBottomMargin={true} title={title} />
                </div>
            </div>
        );
    };

    const purchaseOrderSteps: IPurchase_Order_Progress_State[] = OrderEntryService.getPurchaseOrderSteps(supplierModel);

    const currentStep = props.purchaseOrder.Purchase_Order_State?.id;
    let currentStepNo = 0;

    for (const step of purchaseOrderSteps) {
        if (step.order_state_id === currentStep) {
            currentStepNo = step.step_no;
        }
    }

    return (
        <div className="PurchaseOrderProgressTracker">
            <div
                className={
                    "OrderProgressTracker d-inline-flex align-items-center justify-content-center rounded-5 d-inline-flex p-2 " +
                    (UIService.isMainViewLight() ? "bg-white" : "bg-dark")
                }>
                {purchaseOrderSteps.map((step, index) => {
                    const isSelected = step.step_no <= currentStepNo;

                    if (index > 0) {
                        return (
                            <React.Fragment key={index}>
                                {getChevron(isSelected)}
                                {getStepMarker(step.name, isSelected, true)}
                            </React.Fragment>
                        );
                    } else {
                        return <React.Fragment key={index}>{getStepMarker(step.name, isSelected, true)}</React.Fragment>;
                    }
                })}
            </div>
        </div>
    );
};
